"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cellRenderers_1 = require("./cellRenderers");
exports.GridColumn = function () { return null; };
exports.GridColumn.defaultProps = {
    headerCell: cellRenderers_1.headerCellRenderer,
    cell: cellRenderers_1.textCellRenderer,
    hidden: false
};
//# sourceMappingURL=GridColumn.js.map